const SDK_VERSION = '7.55.2';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
